import { createTheme } from '@mui/material/styles';
import { palettes } from './palette';

export const buildTheme = (mode) =>
  createTheme({
    palette: palettes[mode] ?? palettes.light,
    components: {
      MuiCssBaseline: {
        styleOverrides: (theme) => ({
          html: { colorScheme: theme.palette.mode },
          '*::-webkit-scrollbar': { width: 10, height: 10 },
          '*::-webkit-scrollbar-track': {
            backgroundColor: theme.palette.background.default,
          },
          '*::-webkit-scrollbar-thumb': {
            backgroundColor: theme.palette.mode === 'dark' ? '#3a3453' : '#c4c4cc',
            borderRadius: 5,
            border: `2px solid ${theme.palette.background.default}`,
          },
          '*::-webkit-scrollbar-thumb:hover': {
            backgroundColor: theme.palette.mode === 'dark' ? '#4a4368' : '#a8a8b0',
          },
        }),
      },
      MuiDataGrid: {
        styleOverrides: {
          root: ({ theme }) => ({
            '& .MuiDataGrid-columnHeaders, & .MuiDataGrid-columnHeader, & .MuiDataGrid-columnHeaderRow':
              {
                backgroundColor: theme.palette.custom.surfaceAlt,
              },
            '& .MuiDataGrid-cell': {
              borderColor: theme.palette.divider,
            },
            '& .MuiDataGrid-row:hover': {
              backgroundColor: theme.palette.action.hover,
            },
            '& .MuiDataGrid-footerContainer': {
              backgroundColor: theme.palette.custom.surfaceAlt,
            },
          }),
        },
      },
      MuiTableHead: {
        styleOverrides: {
          root: ({ theme }) => ({
            backgroundColor: theme.palette.custom.surfaceAlt,
          }),
        },
      },
      MuiTableCell: {
        styleOverrides: {
          head: ({ theme }) => ({
            backgroundColor: theme.palette.custom.surfaceAlt,
            fontWeight: 600,
          }),
        },
      },
      MuiInputBase: {
        styleOverrides: {
          // Covers TextField and Select (both render an InputBase/OutlinedInput root).
          root: ({ theme }) => ({
            '&.Mui-disabled': {
              backgroundColor: theme.palette.custom.surfaceAlt,
              cursor: 'not-allowed',
            },
          }),
          // Disabled <input>/<select> elements render their own UA cursor and
          // swallow the hover; disabling pointer events lets the root's
          // not-allowed cursor show through.
          input: {
            '&.Mui-disabled': {
              pointerEvents: 'none',
            },
          },
        },
      },
    },
  });
